import { ResponsiveText } from './ResponsiveText'
import type { HeroFactView } from './getHeroFacts'

export const CohortFactBar = ({ facts }: { facts: HeroFactView[] }) => (
  <dl className='m-0 grid grid-cols-2 lg:flex lg:items-stretch'>
    {facts.map(({ kind, label, value }) => (
      <div
        key={kind}
        data-testid={`cohort-fact-${kind}`}
        className='border-b border-dotted border-c-base-900 py-5 first:pt-0 nth-2:pt-0 lg:border-b-0 lg:border-l lg:px-5 lg:py-0 lg:first:border-l-0 lg:first:pl-0'
      >
        <dt className='c-caption-mono mb-2 uppercase text-c-text-tint-1'>
          <ResponsiveText value={label} />
        </dt>
        <dd className='c-caption-body m-0'>{value}</dd>
      </div>
    ))}
  </dl>
)
